export class Proof {
  constructor(
    public hash?: string,
    public name?: string,
    public description?: string,
    public isActive?: boolean
  ) { }

  clone() {
    return new Proof(
      this.hash,
      this.name,
      this.description,
      this.isActive
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/proof.ts